import React from 'react';
import cx from 'classnames';

import ProgressBar from '@magoosh/lib/progress_bar';

import { ScoredExamSection } from '../types';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

const PerformanceBreakdown: React.FC<ScoredExamSection> = (props) => {
  return (
    <div className="d-flex flex-column" style={{ gap: 20 }}>
      {
        props.performanceBreakdown.map((category, idx) => {
          const noAnswersOrNonCorrect = category.totalAnswerCount === 0 || category.correctAnswerCount === 0;
          const percentCorrect = category.totalAnswerCount === 0 ? 0 : Math.round((category.correctAnswerCount / category.totalAnswerCount) * 100);

          const barColor = noAnswersOrNonCorrect ? colors.grayLighter : colors.brandSecondary;
          const labelColor = noAnswersOrNonCorrect ? colors.grayLight : '#FFFFFF';
          const popOverText =
            category.totalAnswerCount === 0
              ? "You didn't answer any questions for this category"
              : `You answered ${category.correctAnswerCount} questions correctly out of ${category.totalAnswerCount}`;

          return (
            <div key={idx} className="d-flex align-items-center" style={{ gap: 20 }}>
              <div className={cx(style.breakdownName, 'text-right', { 'text-gray-light': category.totalAnswerCount === 0 })}>
                {category.name}
              </div>
              <div className={cx(style.breakdownProgressBar, 'flex-1')}>
                <ProgressBar
                  color={barColor}
                  backgroundColor="#EEEEEF"
                  percentage={percentCorrect === 0 ? 100 : percentCorrect} // Hack: Improper border radius when % is 0 so use 100 w/ the same bg color
                  size="lg"
                  minLabel={category.totalAnswerCount === 0 ? 'N/A' : `${percentCorrect}%`}
                  minLabelStyle={{
                    display: 'flex',
                    alignSelf: 'flex-start',
                    paddingLeft: '10px',
                    color: labelColor
                  }}
                  popoverText={popOverText}
                />
              </div>
            </div>
          );
        })
      }
    </div>
  );
};

export default PerformanceBreakdown;
